/* The all-venues overview: league tables under the terminal's panel chrome.
   Colors are the page tokens from terminal.css. Tables scroll inside their own
   frame so the page never scrolls sideways at phone width. */

.panel {
  margin: 0 0 12px;
}

.leagues {
  align-items: start;
}

.leagues > .panel {
  margin: 0;
}

.coverage {
  margin: -6px 0 12px;
  color: var(--ink-muted);
  font-size: 0.72rem;
}

.footnote {
  margin: 0;
  padding: 8px 10px 10px;
  border-top: 1px solid var(--line);
  color: var(--ink-muted);
  font-size: 0.68rem;
  line-height: 1.45;
}

.scroll {
  max-width: 100%;
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.78rem;
  font-variant-numeric: tabular-nums;
}

.table th {
  padding: 5px 10px;
  border-bottom: 1px solid var(--line);
  color: var(--ink-muted);
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;
}

.table td {
  padding: 5px 10px 6px;
  border-bottom: 1px solid #161613;
  vertical-align: middle;
}

.table tbody tr:last-child td {
  border-bottom: none;
}

.table tbody tr:hover {
  background: var(--signal-soft);
}

.table tr[data-unavailable="true"] .venueLink {
  color: var(--ink-muted);
}

.table th.num,
.table td.num {
  text-align: right;
  white-space: nowrap;
}

.rank {
  width: 2.5em;
  color: var(--ink-muted);
  text-align: right;
}

.strong {
  color: var(--signal);
  font-weight: 700;
}

.venueLink {
  padding: 0;
  border: 0;
  background: none;
  color: var(--signal);
  font: inherit;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  cursor: pointer;
}

.venueLink:hover {
  text-decoration: underline;
  text-underline-offset: 3px;
}

.sub {
  display: block;
  max-width: 16em;
  overflow: hidden;
  color: var(--ink-muted);
  font-size: 0.68rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.muted {
  min-width: 12em;
  color: var(--ink-muted);
  font-size: 0.72rem;
}

.absent {
  color: var(--ink-muted);
}

.share {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 8.5em;
  white-space: nowrap;
}

.shareTrack {
  flex: 0 0 4.5em;
  height: 3px;
  background: #161613;
}

.shareFill {
  display: block;
  height: 100%;
  background: var(--signal);
}

.more {
  display: block;
  width: 100%;
  padding: 7px;
  border: 0;
  border-top: 1px solid var(--line);
  background: #0d0d0d;
  color: var(--signal);
  font: inherit;
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
}

.more:hover {
  background: var(--signal-soft);
}

@media (max-width: 480px) {
  .table th,
  .table td {
    padding-inline: 7px;
  }

  .share {
    min-width: 6.5em;
  }

  .shareTrack {
    flex-basis: 3em;
  }
}

/* A league cell's coverage, under its figure (U-16). */
.coverageLine {
  display: block;
  color: var(--ink-muted);
  font-size: 0.64rem;
  white-space: nowrap;
}

/* Stocks by chain: one chip per chain with its value and token count, doubling as the filter. */
.chainChips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px;
}

.chainChip {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
  min-height: 40px;
  padding: 5px 10px;
  border: 1px solid var(--line-strong);
  border-radius: 8px;
  background: transparent;
  color: var(--ink);
  cursor: pointer;
  font: inherit;
  text-align: left;
}

.chainChip:hover {
  border-color: var(--signal);
}

.chainChip[aria-pressed="true"] {
  border-color: var(--signal);
  background: var(--signal-fill);
  color: var(--on-signal);
}

.chipName {
  font-size: 0.76rem;
  font-weight: 600;
}

.chipFigure {
  color: inherit;
  font-family: var(--mono);
  font-size: 0.66rem;
  opacity: 0.8;
}
